export enum SuccessMessageEnum {
	SMS_SENT = "SMS odeslána",
	SMS_SENT_AGAIN = "Nová SMS odeslána.",
}
